module.exports = __webpack_public_path__ + "img/crush_light_ba_detail_rsh_1.af2ea3be.jpg";